import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import type { PickOption } from 'components/add-members-modal';

/** POST /user-joins/event — `users` là chuỗi id cách nhau bởi dấu phẩy ("1,2"). */
export const addPlayersToVote = (voteId: number, userIds: number[]) =>
  AxiosUtils.post(API.userJoinVote, { voteId, users: userIds.join(',') });

/** GET /votes/search?query= — tìm sự kiện bình chọn theo tên. */
export const searchVoteOptions = async (search: string): Promise<PickOption[]> => {
  const res: any = await AxiosUtils.get(API.voteSearch, { query: search });
  const list: any[] = Array.isArray(res?.data) ? res.data : [];
  return list.map((item) => ({ value: item.id, label: item.title }));
};
